"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AppLayout_1 = __importDefault(require("@/Layouts/AppLayout"));
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var EditorMediaLibrary_1 = __importDefault(require("@/Components/MediaLibrary/EditorMediaLibrary"));
var EditorMetadataModal_1 = __importDefault(require("@/Components/Metadata/EditorMetadataModal"));
function Editor(props) {
    var page = (0, useTypedPage_1.default)();
    var presentationId = props.presentationId, language = props.language;
    var editorUrl = "".concat(process.env.QPLAY_EDITOR_HOST, "/editor").concat(presentationId ? "/".concat(presentationId) : "", "?lng=").concat(language, "&account_id=").concat(page.props.session.current_account.id, "&user_id=").concat(page.props.user.id);
    var editorIframeRef = (0, react_1.useRef)();
    var editorOrPlaylist = (0, react_1.useMemo)(function () {
        return page.url.includes("playlist") ? "Q-Play Playlist Editor" : "Q-Play Editor";
    }, [page.url]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AppLayout_1.default, { title: "Editor", renderHeader: function () { return (react_1.default.createElement("h2", { className: "header" }, editorOrPlaylist)); } },
            react_1.default.createElement("div", { className: "py-0 h-100 w-100", style: { overflowY: "hidden" } },
                react_1.default.createElement("iframe", { src: editorUrl, frameBorder: 0, width: "100%", height: "100%", allow: "autoplay", ref: editorIframeRef, "data-cy": "editor-iframe" }))),
        react_1.default.createElement(EditorMediaLibrary_1.default, { editorIframeRef: editorIframeRef }),
        react_1.default.createElement(EditorMetadataModal_1.default, { editorIframeRef: editorIframeRef })));
}
exports.default = Editor;
